import initStickyBookingForm from './stickyBookingForm';
import { initMenu } from './menu';
import { initNewsletterSignup } from './newsletterSignup';
import initOpeningHours from './openingHours';
import initSocialSharing from './socialSharing';
import { initBrowserCompatability } from './browserCompatibility';
import { initLazyLoad } from './lazyLoad';

const pageFunctions = {
  common: {
    init() {
      
    },

    finalize() {
     
      initMenu();
      initOpeningHours();
      initNewsletterSignup();
      initSocialSharing();
      initStickyBookingForm();
      initBrowserCompatability();
      initLazyLoad();
    },
    loaded() {
      
    }
  }
};

const executePageFunctions = (finalize = false, loaded = false) => {
  const body = document.body;

  
  
  if (loaded) {
    pageFunctions.common.loaded();
  } else if (finalize && !loaded) {
    pageFunctions.common.finalize();
  } else {
    pageFunctions.common.init();
  }

  for (let c of body.classList) {
    c = c.replace(/-/g, '_');

    if (loaded) {
      if (typeof pageFunctions[c] !== 'undefined') {
        if (typeof pageFunctions[c].loaded !== 'undefined') {
          pageFunctions[c].loaded();
        }
      }
      return;
    }

    if (finalize) {
      if (typeof pageFunctions[c] !== 'undefined') {
        if (typeof pageFunctions[c].finalize !== 'undefined') {
          pageFunctions[c].finalize();
        }
      }
      return;
    }

    if (typeof pageFunctions[c] !== 'undefined') {
      if (typeof pageFunctions[c].init !== 'undefined') {
        pageFunctions[c].init();
      }
    }

  }
};

document.addEventListener('DOMContentLoaded', function () {
  executePageFunctions(true);
});

window.addEventListener('load', function () {
  executePageFunctions(true, true);
});
executePageFunctions();
